@for (formStep of formSteps; track formStep; let index = $index) {
  <wl-progressive-generic-form
    [rendering]="extractFieldsFromStep(formStep)"
    [trackStep]="getTrackStepConfig(formStep, index)"
    [formState]="$any(formStep.formState | async)"
    [progressiveFormSelectorKey]="progressiveFormSelectorKey"
    (formSubmitted)="submittedAtIndex(index)"
  ></wl-progressive-generic-form>
}
